import {
  updateResourceState,
  createResourceReducer,
  RESOURCE,
  RECORD_FIELD
} from 'react-structure-admin';

import {
  FINANCIALENTRY,
  FINANCIALENTRY_CANCEL_INVOICE_FINISHED,
  FINANCIALENTRY_CHANGE_TO_EXPORT,
  FINANCIALENTRY_CHANGE_TO_EXPORT_FINISHED,
  FINANCIALENTRY_CLOSE_DETAIL,
  FINANCIALENTRY_CLOSE_INVOICE,
  FINANCIALENTRY_CLOSE_RESEND_EMAIL_INVOICE,
  FINANCIALENTRY_DELETE,
  FINANCIALENTRY_DELETE_FINISHED,
  FINANCIALENTRY_EXPORT,
  FINANCIALENTRY_EXPORT_CSV,
  FINANCIALENTRY_EXPORT_CSV_FINISHED,
  FINANCIALENTRY_EXPORT_FINISHED,
  FINANCIALENTRY_OPEN_DETAIL,
  FINANCIALENTRY_OPEN_DETAIL_FINISHED,
  FINANCIALENTRY_OPEN_INVOICE_FINISHED,
  FINANCIALENTRY_OPEN_RESEND_EMAIL_INVOICE,
  FINANCIALENTRY_POST,
  FINANCIALENTRY_POST_FINISHED,
  FINANCIALENTRY_REFRESH,
  FINANCIALENTRY_RESEND_EMAIL_INVOICE,
  FINANCIALENTRY_RESEND_EMAIL_INVOICE_FINISHED,
  FINANCIALENTRY_OPEN_TRANSFER,
  FINANCIALENTRY_CLOSE_TRANSFER,
  FINANCIALENTRY_CREATE_TRANSFER,
  FINANCIALENTRY_CREATE_TRANSFER_FINISHED,
  FINANCIALENTRY_DELETE_TRANSFER,
  FINANCIALENTRY_DELETE_TRANSFER_FINISHED
} from './financialEntryActions';

const financialEntryReducer = createResourceReducer(
  FINANCIALENTRY,
  [],
  {
    [FINANCIALENTRY_OPEN_INVOICE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [RECORD_FIELD]: action.payload.data.result,
        editingInvoice: true,
        editing: true,
        visible: true
      }));
    },

    [FINANCIALENTRY_CLOSE_INVOICE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [RECORD_FIELD]: null,
        editingInvoice: false,
        editing: false,
        visible: false
      }));
    },

    [FINANCIALENTRY_CANCEL_INVOICE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    },

    [FINANCIALENTRY_REFRESH](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    },

    [FINANCIALENTRY_OPEN_RESEND_EMAIL_INVOICE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        resendEmailData: action.payload
      }));
    },

    [FINANCIALENTRY_CLOSE_RESEND_EMAIL_INVOICE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        resendEmailData: null
      }));
    },

    [FINANCIALENTRY_CLOSE_RESEND_EMAIL_INVOICE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        resendEmailData: null
      }));
    },

    [FINANCIALENTRY_RESEND_EMAIL_INVOICE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        saving: true
      }));
    },

    [FINANCIALENTRY_RESEND_EMAIL_INVOICE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        resendEmailData: null,
        saving: false
      }));
    },

    [FINANCIALENTRY_POST](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [RECORD_FIELD]: action.payload,
        saving: true
      }));
    },

    [FINANCIALENTRY_POST_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [RECORD_FIELD]: null,
        saving: false,
        editing: false,
        loaded: false
      }));
    },

    [FINANCIALENTRY_OPEN_DETAIL](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({}));
    },

    [FINANCIALENTRY_OPEN_DETAIL_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        viewDetail: action.payload.data.result
      }));
    },

    [FINANCIALENTRY_CLOSE_DETAIL](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        viewDetail: null
      }));
    },

    [FINANCIALENTRY_DELETE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        deleting: true
      }));
    },

    [FINANCIALENTRY_DELETE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [RECORD_FIELD]: null,
        saving: false,
        editing: false,
        loaded: false,
        deleting: false
      }));
    },

    [FINANCIALENTRY_EXPORT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        exporting: true
      }));
    },

    [FINANCIALENTRY_EXPORT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        exporting: false,
        exportedItems: action.payload.data.result
      }));
    },

    [FINANCIALENTRY_CHANGE_TO_EXPORT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        exporting: true
      }));
    },

    [FINANCIALENTRY_CHANGE_TO_EXPORT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        exporting: false
      }));
    },

    [FINANCIALENTRY_EXPORT_CSV](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        exportingExcel: true
      }));
    },

    [FINANCIALENTRY_EXPORT_CSV_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        exportingExcel: false
      }));
    },

    [FINANCIALENTRY_OPEN_TRANSFER](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        openTransfer: true
      }));
    },

    [FINANCIALENTRY_CLOSE_TRANSFER](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        openTransfer: false
      }));
    },

    [FINANCIALENTRY_CLOSE_TRANSFER](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        openTransfer: false
      }));
    },

    [FINANCIALENTRY_CREATE_TRANSFER](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        saving: true
      }));
    },

    [FINANCIALENTRY_CREATE_TRANSFER_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        saving: false,
        openTransfer: false,
        loaded: false
      }));
    },

    [FINANCIALENTRY_DELETE_TRANSFER](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({}));
    },

    [FINANCIALENTRY_DELETE_TRANSFER_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    }
  },

  (state, action) => {
    return updateResourceState(state, action, RESOURCE, () => ({
      saving: false,
      deleting: false,
      exportingExcel: false
    }));
  }
);

export default financialEntryReducer;
